import WebServiceRequest from "../Api/WebServiceRequest";

class SeoRedirectManagementGetAll extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setMethod('GET')
        super.setTag(`SeoRedirectManagement/GetAll`);
    }
    setParams(data) {
       super.setRequestParam(data)
    }
}

class SeoRedirectManagementGetSeoData extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setMethod('GET')
    }
    setParams(data) {
        super.setTag(`SeoRedirectManagement/GetSeoData/${data}`);
    }
}

class SeoRedirectManagementUpdateSeoData extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("SeoRedirectManagement/UpdateSeoData");
    }
    setRequestParams(data) {
        super.setRequestParamDataObj(data);
    }
}

class SeoRedirectManagementRedirectUrl extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setMethod('GET')
    }
    setParams(data) {
        super.setTag(`SeoRedirectManagement/RedirectUrl/redirect/${data}`);
    }
}

class SeoRedirectManagementDelete extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("SeoRedirectManagement/Delete");
    }
    setRequestParams(data) {
        super.setRequestParam(data);
    }
}

export {
    SeoRedirectManagementGetAll,
    SeoRedirectManagementGetSeoData,
    SeoRedirectManagementUpdateSeoData,
    SeoRedirectManagementRedirectUrl,
    SeoRedirectManagementDelete
}